/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSimilarItemsContainer_item = {
    readonly isSold: boolean | null;
    readonly seller: {
        readonly isAccessible: boolean | null;
    } | null;
    readonly " $refType": "PdpRespSimilarItemsContainer_item";
};
export type PdpRespSimilarItemsContainer_item$data = PdpRespSimilarItemsContainer_item;
export type PdpRespSimilarItemsContainer_item$key = {
    readonly " $data"?: PdpRespSimilarItemsContainer_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsContainer_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsContainer_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '003dd6f801c2970770a4e76f447c39ef';
export default node;
